import Button from "../../../SharedComponents/Button";

import { BUTTON_VARIANT_TYPES, NO_ACCESS_TYPES, PERMISSIONS } from "../../../../utils/constants";
import { DownloadIcon, ChevronRightIcon } from "@heroicons/react/solid";
import SubsequentFileRow from "./SubsequentFileRow";
import AccessControl from "../../../SharedComponents/AccessControl";

function VersionRow(props) {
    const {
        version,
        documentIdentifier,
        handleDownloadVersion,
        handleDownloadSubsequentFile,
        showSubsequentFiles,
        handleShowSubsequentFiles,
        currentlyDownloading
    } = props;

    return (
        <>
            <tr>
                <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex flex-row gap-4 items-center">
                        <div className="text-sm text-blue-gray-500 mt-1">{version.versionNumber}</div>
                    </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex flex-row gap-4 items-center">
                        <div className="text-sm text-blue-gray-500 mt-1">
                            {new Date(version.reportDate).toLocaleDateString()}
                        </div>
                    </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex flex-row gap-4 items-center">
                        <div className="text-sm text-blue-gray-500 mt-1">{version.fileFormat.toUpperCase()}</div>
                    </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap">
                    <div className={"flex flex-row gap-3 items-center"}>
                        <Button
                            onClick={() =>
                                handleDownloadVersion(documentIdentifier, version.versionNumber, version.fileFormat)
                            }
                            iconPositionLeft
                            icon={<DownloadIcon className="block h-3.5 w-3.5 mr-2" />}
                            colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                            text="Download"
                            extraStyling="shadow-none text-primary-600 p-0 focus:ring-0 focus:transparent"
                            loading={currentlyDownloading === version.versionNumber}
                            disabled={currentlyDownloading}
                        />
                    </div>
                </td>
                <AccessControl
                    requiredPermission={PERMISSIONS.DOWNLOAD_ADDITIONAL_FILES}
                    noAccessType={NO_ACCESS_TYPES.BLANK}
                >
                    <td className="py-3 whitespace-nowrap">
                        <div className={"flex flex-row gap-3 items-center"}>
                            <ChevronRightIcon
                                className={
                                    "block h-5 w-5 mr-4 cursor-pointer transition transition-transform transform " +
                                    (showSubsequentFiles && "rotate-90")
                                }
                                onClick={handleShowSubsequentFiles}
                            />
                        </div>
                    </td>
                </AccessControl>
            </tr>
            {showSubsequentFiles && (
                <tr>
                    <td className="bg-blue-gray-200 p-2" colSpan={5}>
                        <div className="flex justify-center">
                            {version.subsequentFiles.length !== 0 ? (
                                <div className="overflow-hidden border-b border-none shadow-sm sm:rounded-lg w-full">
                                    <table className="w-full">
                                        <thead>
                                            <tr className="bg-blue-gray-50">
                                                <th
                                                    scope="col"
                                                    className="px-4 py-3 text-left text-xs font-medium text-blue-gray-500
                        uppercase font-mono tracking-wider"
                                                >
                                                    Additional File Name
                                                </th>
                                                <th
                                                    scope="col"
                                                    className="px-4 py-3 text-left text-xs font-medium text-blue-gray-500
                        uppercase font-mono tracking-wider"
                                                >
                                                    File Type
                                                </th>
                                                <th
                                                    scope="col"
                                                    className="px-4 py-3 text-left text-xs font-medium text-blue-gray-500
                        uppercase font-mono tracking-wider"
                                                >
                                                    Download
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white">
                                            {version.subsequentFiles.map((subsequentFile) => (
                                                <SubsequentFileRow
                                                    key={subsequentFile.identifier}
                                                    documentIdentifier={documentIdentifier}
                                                    subsequentFile={subsequentFile}
                                                    handleDownloadSubsequentFile={handleDownloadSubsequentFile}
                                                    currentlyDownloading={currentlyDownloading}
                                                />
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className={"px-2 py-3 ml-2 text-blue-gray-500"}>
                                    This version of the document has no additional files
                                </div>
                            )}
                        </div>
                    </td>
                </tr>
            )}
        </>
    );
}

export default VersionRow;
